module.exports = __webpack_public_path__ + "img/contratos.ba844190.svg";